import { Component } from '@theme/component';

const STORAGE_KEY = 'eilveiaan:editorial:wishlist:v1';
class EvStoreTools extends Component {
  #abort;
  #items = [];
  connectedCallback() {
    super.connectedCallback();
    this.#abort = new AbortController();
    this.#load();
    // Keep Escape within the top dialog; the mobile drawer also handles keyup.
    this.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && event.target.closest('dialog[open]')) {
        event.preventDefault();
        event.stopPropagation();
      }
    }, { signal: this.#abort.signal });
    this.addEventListener('keyup', (event) => {
      if (event.key === 'Escape' && event.target.closest('dialog[open]')) {
        event.stopPropagation();
        this.closeDialogs();
      }
    }, { signal: this.#abort.signal });
    window.addEventListener('storage', (event) => {
      if (event.key === STORAGE_KEY || event.key === null) this.#load();
    }, { signal: this.#abort.signal });
  }
  disconnectedCallback() {
    super.disconnectedCallback();
    this.#abort?.abort();
  }
  #valid(item) {
    return item && typeof item.handle === 'string' && /^[a-z0-9-]+$/.test(item.handle)
      && typeof item.title === 'string' && typeof item.url === 'string'
      && /^\/(?:[a-z]{2}(?:-[A-Z]{2})?\/)?products\/[a-z0-9-]+$/.test(item.url)
      && (item.image === '' || (typeof item.image === 'string' && /^(https:\/\/|\/\/)(cdn\.shopify\.com|eilveiaanhome\.com)\//.test(item.image)));
  }
  #load() {
    try {
      const stored = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
      this.#items = Array.isArray(stored) ? stored.filter(item => this.#valid(item)) : [];
      this.#render();
    } catch {
      this.#error();
    }
  }
  #error(open = false) {
    const status = this.querySelector('[data-wishlist-status]');
    if (status) status.textContent = this.dataset.errorLabel;
    if (open) this.querySelector('#ev-wishlist-dialog')?.showModal();
  }
  #save(items) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
      this.#items = items;
      this.querySelector('[data-wishlist-status]').textContent = '';
      this.#render();
      return true;
    } catch {
      this.#error(true);
      return false;
    }
  }
  #render() {
    const list = this.querySelector('[data-wishlist-items]');
    if (!list) return;
    list.replaceChildren();
    this.querySelector('[data-wishlist-empty]').hidden = this.#items.length > 0;
    for (const item of this.#items) {
      const row = document.createElement('li');
      const image = document.createElement('img');
      image.alt = ''; image.loading = 'lazy'; image.width = 64; image.height = 80;
      if (item.image) image.src = item.image;
      else image.hidden = true;
      const link = document.createElement('a');
      link.href = item.url; link.textContent = item.title;
      const remove = document.createElement('button');
      remove.type = 'button'; remove.className = 'button-unstyled';
      remove.textContent = this.dataset.removeLabel;
      remove.setAttribute('aria-label', `${this.dataset.removeLabel}: ${item.title}`);
      remove.addEventListener('click', () => {
        if (this.#save(this.#items.filter(saved => saved.handle !== item.handle))) {
          this.querySelector('#ev-wishlist-dialog button')?.focus();
        }
      }, { signal: this.#abort.signal });
      row.append(image, link, remove); list.append(row);
    }
    for (const button of document.querySelectorAll('[data-save-product]')) {
      const saved = this.#items.some(item => item.handle === button.dataset.productHandle);
      button.setAttribute('aria-pressed', String(saved));
      const label = button.querySelector('span');
      if (label) label.textContent = saved ? this.dataset.savedLabel : this.dataset.saveLabel;
    }
  }
  openWishlist() {
    this.#load();
    const dialog = this.querySelector('#ev-wishlist-dialog');
    if (!dialog.open) dialog.showModal();
  }
  toggleProduct(event) {
    const button = event.target.closest('[data-save-product]');
    if (!button) return;
    const item = { handle: button.dataset.productHandle, title: button.dataset.productTitle, url: button.dataset.productUrl, image: button.dataset.productImage || '' };
    if (!this.#valid(item)) { this.#error(true); return; }
    const existing = this.#items.some(saved => saved.handle === item.handle);
    this.#save(existing ? this.#items.filter(saved => saved.handle !== item.handle) : [...this.#items, item]);
  }
  openHelp() { this.querySelector('#ev-help-dialog')?.showModal(); }
  closeDialogs() { for (const dialog of this.querySelectorAll('dialog[open]')) dialog.close(); }
  dismissHelp() { this.querySelector('.ev-help-rail').hidden = true; }
}
if (!customElements.get('ev-store-tools')) customElements.define('ev-store-tools', EvStoreTools);
